import { FC, useEffect, useMemo, useState } from "react";
import { ExchangeRateHistoricalDto } from "../../interfaces/Dtos";
import { getHistoricalExchangeRates } from "../../services/currencyServices";
import HorizontalPadding from "../../components/HorizontalPadding";
import PaginationFooter from "../../components/PaginationFooter";
import moment from "moment";

const ROWS_PER_PAGE = 20;
const DISPLAY_DATE_TIME_FORMAT = "DD/MM/YYYY hh:mm A";

const formatDate = (value?: string | Date | null) => {
  if (!value) return "-";

  const rawValue = String(value).trim();
  const normalizedValue = rawValue
    .replace(/\s+/g, " ")
    .replace(/\s([AaPp][Mm])$/, "$1");
  const parsedDate = moment(
    normalizedValue,
    [
      moment.ISO_8601,
      "YYYY/MM/DD h:mmA",
      "YYYY/MM/DD hh:mmA",
      "YYYY/MM/DD h:mm A",
      "YYYY/MM/DD hh:mm A",
      "YYYY/MM/DD HH:mm",
      "YYYY-MM-DD HH:mm:ss",
      "YYYY-MM-DDTHH:mm:ss",
      "YYYY-MM-DDTHH:mm:ss.SSSZ",
      "DD/MM/YYYY",
    ],
    true
  );

  if (parsedDate.isValid()) {
    return parsedDate.format(DISPLAY_DATE_TIME_FORMAT);
  }

  const fallbackDate = moment(normalizedValue);
  return fallbackDate.isValid()
    ? fallbackDate.format(DISPLAY_DATE_TIME_FORMAT)
    : rawValue;
};

const ExchangeRateHistorical: FC = () => {
    const [history, setHistory] = useState<ExchangeRateHistoricalDto[]>([]);
  const [refresh, setRefresh] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const paginatedHistory = useMemo(() => {
    return history.slice(itemOffset, itemOffset + ROWS_PER_PAGE);
  }, [history, itemOffset]);

  // Handle page click
  const handlePageClick = (event: { selected: number }) => {
    const newOffset = (event.selected * ROWS_PER_PAGE) % history?.length;
    setItemOffset(newOffset);
  };
  useEffect(() =>{
        const fetchHistoricalRates = async () => {
            try {
                const response = await getHistoricalExchangeRates();
                console.log(response);
                if (!response.didError && response.model) {
                    setHistory(response.model);
                } else {
                    console.error("Error fetching historical exchange rates:", response.errorMessage);
                }
            } catch (error) {
                console.error("Error fetching historical exchange rates:", error);
            }
        };
        fetchHistoricalRates();
  }, []);

    useEffect(() => {
      setTotalPages(Math.ceil(history.length / ROWS_PER_PAGE));
    }, [itemOffset, history]);

  return (
    <main className="lg:pl-72 pb-32">
      <div className="py-6 sm:px-6 lg:px-8 bg-white relative flex items-center justify-between h-32">
        <header className="ml-4 text-2xl font-bold text-gray-700 ">
          Histórico de Tasa de cambio
        </header>
      </div>

      {history.length > 0 && (
        <div className="overflow-x-auto border border-gray-300 rounded-lg border px-8 pb-6 pt-4 mb-32">
          <table className="table-auto w-full">
            <thead>
              <tr className="text-center bg-gray-200">
                <th className="px-4 py-2 font-semibold text-xs">FECHA VALOR</th>
                <th className="px-4 py-2 font-semibold text-xs">MONEDA</th>
                <th className="px-4 py-2 font-semibold text-xs">
                  Tasa de cambio
                </th>
                <th className="px-4 py-2 font-semibold text-xs">
                  Fecha de creación
                </th>
              </tr>
            </thead>

            <tbody>
              {paginatedHistory.map((m, index) => (
                <tr
                  key={m.exchangeRateID}
                  className={`hover:bg-gray-100 text-center ${
                    index % 2 === 0 ? "bg-gray-50" : "bg-white"
                  }`}
                >
                    <td className="px-4 py-4 text-xs text-gray-700 font-semibold truncate"> 
                    {formatDate(m.valueDate)}
                  </td>
                  <td className="px-4 py-4 text-xs text-gray-700 font-semibold truncate">
                    {m.currency?.toUpperCase()}
                  </td>
                  <td className="px-4 py-4 text-xs text-gray-700 font-semibold truncate">
                    {m.exchangeRateBuy}
                  </td>
                  <td className="px-4 py-4 text-xs text-gray-700 font-semibold truncate">
                    {moment(m.creationDate).format("DD/MM/YYYY")}
                  </td>

                </tr>
              ))}
            </tbody>
          </table>

          <PaginationFooter
            rowCounts={ROWS_PER_PAGE}
            itemsOffSet={itemOffset}
            totalItems={history.length}
            handlePageClick={handlePageClick}
            totalPages={totalPages}
          />
        </div>
      )}
    </main>
  );
};

export default ExchangeRateHistorical;
